/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon16Solid = forwardRef('ArrowShapeADownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.587 14.396a2 2 0 0 0 2.828 0l5.689-5.689c.63-.63.183-1.707-.707-1.707H12V2.75A1.75 1.75 0 0 0 10.25 1h-4.5A1.75 1.75 0 0 0 4 2.75V7H1.604C.713 7 .266 8.077.897 8.707l5.69 5.69Z" })));
});
